import * as d3 from 'd3';

export const reset = (chart, legend) => {
  const body = d3.select('body');

  chart.selectAll('svg').remove();
  legend.selectAll('.legend-item').remove();

  body.selectAll('#tooltip').remove();
};
